const shopActionType = {
  // shop
  FETCH_SHOP: "FETCH_SHOP",
  FETCH_SHOP_SUCCESS: "FETCH_SHOP_SUCCESS",
  FETCH_SHOP_FAILURE: "FETCH_SHOP_FAILURE",
  // custom domain
  FETCH_CUSTOM_DOMAIN: "FETCH_CUSTOM_DOMAIN",
  FETCH_CUSTOM_DOMAIN_SUCCESS: "FETCH_CUSTOM_DOMAIN_SUCCESS",
  FETCH_CUSTOM_DOMAIN_FAILURE: "FETCH_CUSTOM_DOMAIN_FAILURE",
  UPDATE_CUSTOM_DOMAIN: "UPDATE_CUSTOM_DOMAIN",
  // ONLY IN V1
  // subscribe confirm url
  STORE_SUBSCRIBE_CONFIRMATION_URL: "STORE_SUBSCRIBE_CONFIRMATION_URL",
  REMOVE_SUBSCRIBE_CONFIRMATION_URL: "REMOVE_SUBSCRIBE_CONFIRMATION_URL",
  // review
  ASK_REVIEW: "ASK_REVIEW",
  SEND_REVIEW: "SEND_REVIEW",
  SEND_REVIEW_SUCCESS: "SEND_REVIEW_SUCCESS",
  SEND_REVIEW_FAILURE: "SEND_REVIEW_FAILURE",

  // theme app extension
  VALIDATE_THEME_EXTENSION_APP_ENABLED: "VALIDATE_THEME_EXTENSION_APP_ENABLED",
  VALIDATE_THEME_EXTENSION_APP_ENABLED_SUCCESS: "VALIDATE_THEME_EXTENSION_APP_ENABLED_SUCCESS",
  VALIDATE_THEME_EXTENSION_APP_ENABLED_FAILURE: "VALIDATE_THEME_EXTENSION_APP_ENABLED_FAILURE",
  // V2 theme extension
  UPDATE_THEME_EXTENSION_STATUS: "UPDATE_THEME_EXTENSION_STATUS",
};

export default shopActionType;
